import gql from 'graphql-tag'

export const FOOTER_QUERY = gql`
query {
  setting {
    data {
      attributes {
        Footer {
          newsletterTitle
          NewsletterCaption
          Copyright
        }
      }
    }
  }
}
`;
